// extracted by mini-css-extract-plugin
export var autoExpand = "_1s-8";
export var container = "_1s-7";
export var containerWidth = "_1s-5";
export var disabled = "_1s-2";
export var error = "_1s-3";
export var fullWidth = "_1s-6";
export var inputWrapper = "_1s-0";
export var small = "_1s-1";
export var textarea = "_1s-4";